import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import apiClient from '../api/client';
import { fetchAuthStatus } from '../auth/status';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [authRequired, setAuthRequired] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const statusData = await fetchAuthStatus();
        setAuthRequired(statusData.authRequired);
        if (!statusData.authRequired) {
          setAuthRequired(false);
          setAuthenticated(true);
          return;
        }

        const meResp = await fetch(apiClient.resolveUrl('/api/auth/me'), {
          credentials: 'include',
          headers: apiClient.getAuthHeaders(),
        });
        setAuthenticated(meResp.ok);
      } catch {
        setAuthenticated(false);
      } finally {
        setChecking(false);
      }
    };

    void checkAuth();
  }, []);

  if (authenticated && !checking) {
    return <>{children}</>;
  }

  if (checking) return null;

  if (authRequired) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
